import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=64f019c6&lang=html"
import script from "./Richtext.vue?vue&type=script&lang=js"
export * from "./Richtext.vue?vue&type=script&lang=js"
import style0 from "./Richtext.vue?vue&type=style&index=0&id=64f019c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports